var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgJudiBrandLogo = function SvgJudiBrandLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "judi-logo",
    className: "icon-brand",
    "aria-label": "Logo",
    "data-brand": "Judi Rx",
    "data-purpose": "Brand Identity",
    title: "Judi Health",
    role: "img",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-.7 11.8v3.4H7.6a1.7 1.7 0 0 1 0-3.4zm.7 3.4V8.4a3.4 3.4 0 1 1 0 6.8m3.4-5.7a4 4 0 0 0-3.4-2V6a1.7 1.7 0 0 1 3.4 0zm14 5.7q-1 0-1.8-.4-.7-.5-1.2-1.4l1.2-.8.7.7q.4.3 1 .3t1-.5q.5-.4.5-1.6v-7h1.8v7.2q0 1-.3 1.7-.3.9-1 1.3-.8.5-2 .5m8 0q-1.2 0-1.8-.8A4 4 0 0 1 33 12V7h1.8v4.7q0 1 .3 1.4t1 .4q.5 0 .8-.2l.9-.9V7.1h1.8V15h-1.5l-.1-1.2q-.6.7-1.2 1t-1.4.4m9.3 0q-1.5 0-2.3-1.1-1-1-1-3 0-1.3.5-2.2t1.3-1.5a3 3 0 0 1 2.7-.2q.6.2 1 .6V3.7h1.8V15H47l-.1-.8-1 .7zm.5-1.5.8-.2.8-.7V9l-.8-.5-.8-.1q-.4 0-1 .3l-.6.9-.2 1.4q0 1.3.5 1.9t1.3.7M51 15V7.1h1.8V15zm1-9.2q-.6 0-.9-.3l-.3-.8q0-.5.3-.7.3-.3.8-.3t.8.3.3.7-.3.8-.8.3"
  })));
};
export { SvgJudiBrandLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/judi-brand-logo.26581b00.svg";